import script from "./LoginComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./LoginComponent.vue?vue&type=script&setup=true&lang=js"

import "./LoginComponent.vue?vue&type=style&index=0&id=171ff5ea&scoped=true&lang=css"

import exportComponent from "E:\\gcm3\\AI Inventory\\codebase\\demo-legacy-frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-171ff5ea"]])

export default __exports__